import { PVFile } from './PVFile';
import { PVCurve } from './PVCurve';
import assignToThis from '../../helper/assignToThis';
import { SurfaceDefinition } from './SurfaceDefinition';

export class ScenarioPV {
  public hasUploadedPV: boolean | null = true;
  public hasSurfaceDefinition: boolean | null = null;

  public file: PVFile | null = null;
  public surfaceDefinition: SurfaceDefinition | null = null;

  public calculatedCurve: PVCurve | null = null;

  public moduleRef: string | null = null;

  public invertersLifetime: number | null = null;
  public maintenanceEfficiency: number | null = null;
  public panelCapacity: number | null = null;
  public panelArea: number | null = null;
  public panelDegradation: number | null = null;

  public annualYieldResults: number | null = null;
  public energy: number | null = null;

  public constructor(obj: object = {}) {
    assignToThis(this, obj);

    this.file = this.file ? new PVFile(this.file) : null;
    this.surfaceDefinition = this.surfaceDefinition ? new SurfaceDefinition(this.surfaceDefinition) : null;
    this.calculatedCurve = this.calculatedCurve ? new PVCurve(this.calculatedCurve) : null;
  }

}
